import type { ComponentProps } from 'react'

import { cn } from '../../lib/utils'

const Textarea = ({ className, ref, ...props }: ComponentProps<'textarea'>) => (
  <textarea
    ref={ref}
    className={cn(
      'border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm placeholder:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
)
Textarea.displayName = 'Textarea'

export { Textarea }
